"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeEventTypes = exports.TextResourceItemTypes = exports.TemplateTypes = exports.TemplateLayoutsByType = exports.TemplateLayouts = exports.SpeechTypes = exports.ScrollableAnnotations = exports.RetakePanelType = exports.ResourceTypes = exports.ResourceItemTypes = exports.ReportTypes = exports.QuizStates = exports.OutlineTypes = exports.NotificationTypes = exports.NavStatuses = exports.ExcerptPositions = exports.ElementPositions = exports.EditorBodyId = exports.CustomNavType = exports.CopyTypes = exports.CataTypes = exports.AnnotationTypes = exports.AdaptiveTypes = exports.AccessTypes = void 0;
var _TemplateLayoutsByTyp, _TextResourceItemType;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var ResourceTypes = {
  Audio: 'Audio',
  Image: 'Image',
  Stateful: 'Stateful',
  Text: 'Text',
  Document: 'Document'
};
exports.ResourceTypes = ResourceTypes;
var AnnotationTypes = {
  Tooltip: 'Tooltip',
  Highlight: 'Highlight',
  Strikethrough: 'Strikethrough',
  Addition: 'Addition',
  Note: 'Note',
  Correct: 'Correct',
  Incorrect: 'Incorrect',
  Snippet: 'Snippet',
  Delete: 'Delete',
  Overlay: 'Overlay',
  Focus: 'Focus',
  Delete_v2: 'Delete_v2',
  Addition_v2: 'Addition_v2',
  Dynamic: 'Dynamic',
  AnswerBase: 'AnswerBase',
  Choice: 'Choice'
};
exports.AnnotationTypes = AnnotationTypes;
var ResourceItemTypes = {
  Audio: 'Audio',
  Document: 'Document',
  Text: 'Text',
  Annotation: 'Annotation',
  Provision: 'Provision',
  Answer: 'Answer'
};
exports.ResourceItemTypes = ResourceItemTypes;
var TemplateTypes = {
  CheckAllApply: 'CheckAllApply',
  ClickBestSpot: 'ClickBestSpot',
  ChooseBestProvision: 'ChooseBestProvision',
  Conclusions: 'Conclusions',
  Explanation: 'Explanation'
};
exports.TemplateTypes = TemplateTypes;
var TemplateLayouts = {
  Content: {
    Single: [1],
    'Tri-panel': [1 / 3, 1 / 3, 1 / 3],
    'Left Heavy': [2 / 3, 1 / 3],
    'Right Heavy': [1 / 3, 2 / 3],
    'Center Heavy': [1 / 4, 1 / 2, 1 / 4],
    Split: [1 / 2, 1 / 2]
  },
  Quiz: {
    'Right Heavy': [1 / 3, 2 / 3]
  },
  Conclusions: {
    Single: [1]
  },
  Introductory: {
    'Left Heavy': [2 / 3, 1 / 3],
    'Right Heavy': [1 / 3, 2 / 3],
    'Center Heavy': [1 / 4, 1 / 2, 1 / 4],
    Single: [1]
  },
  CheckAllApply: {
    'Tri-panel': [0.32, 0.4, 0.28],
    'Right Heavy': [1 / 3, 2 / 3]
  }
};
exports.TemplateLayouts = TemplateLayouts;
var TemplateLayoutsByType = (_TemplateLayoutsByTyp = {}, _defineProperty(_TemplateLayoutsByTyp, TemplateTypes.CheckAllApply, TemplateLayouts.CheckAllApply), _defineProperty(_TemplateLayoutsByTyp, TemplateTypes.ClickBestSpot, TemplateLayouts.Quiz), _defineProperty(_TemplateLayoutsByTyp, TemplateTypes.ChooseBestProvision, TemplateLayouts.Quiz), _defineProperty(_TemplateLayoutsByTyp, TemplateTypes.Conclusions, TemplateLayouts.Conclusions), _defineProperty(_TemplateLayoutsByTyp, TemplateTypes.Explanation, TemplateLayouts.Content), _TemplateLayoutsByTyp);
exports.TemplateLayoutsByType = TemplateLayoutsByType;
var TextResourceItemTypes = (_TextResourceItemType = {}, _defineProperty(_TextResourceItemType, ResourceItemTypes.Text, true), _defineProperty(_TextResourceItemType, ResourceItemTypes.Document, true), _TextResourceItemType);
exports.TextResourceItemTypes = TextResourceItemTypes;
var AdaptiveTypes = {
  notAdaptive: 'NOT_ADAPTIVE',
  immediate: 'IMMEDIATE',
  queued: 'QUEUED',
  primary: 'PRIMARY'
};
exports.AdaptiveTypes = AdaptiveTypes;
var SpeechTypes = {
  InitialGreeting: 'initialGreeting',
  TryAgain: 'tryAgain',
  Feedback: 'feedback'
};
exports.SpeechTypes = SpeechTypes;
var AccessTypes = {
  Course: 'Course',
  Module: 'Module',
  Slide: 'Slide',
  Resource: 'Resource'
};
exports.AccessTypes = AccessTypes;
var ReportTypes = {
  None: 'NONE',
  Performance: 'PERFORMANCE',
  PrePost: 'PRE_POST'
};
exports.ReportTypes = ReportTypes;
var ElementPositions = {
  Before: 'BEFORE',
  After: 'AFTER',
  FirstChild: 'FIRST_CHILD',
  LastChild: 'LAST_CHILD'
};
exports.ElementPositions = ElementPositions;
var CataTypes = {
  Standard: 'STANDARD',
  Comment: 'COMMENT',
  Provision: 'PROVISION',
  EditHorizontal: 'BEST_EDIT',
  EditVertical: 'EDIT_VERTICAL'
};
exports.CataTypes = CataTypes;
var QuizStates = {
  Correct: 'correct',
  AllWrong: 'allWrong',
  SomeWrong: 'someWrong'
};
exports.QuizStates = QuizStates;
var OutlineTypes = {
  Default: null,
  Number: 'NUMBER',
  LowerLetter: 'LOWER_LETTER',
  LowerRoman: 'LOWER_ROMAN',
  UpperRoman: 'UPPER_ROMAN',
  UpperLetter: 'UPPER_LETTER',
  ArticleRoman: 'ARTICLE_ROMAN',
  TwoDigitSection: 'TWO_DIGIT_SECTION',
  NumberParen: 'NUMBER_PAREN',
  LowerLetterParen: 'LOWER_LETTER_PARENT',
  UpperLetterParen: 'LOWER_LETTER_PAREN',
  LowerRomanParen: 'LOWER_ROMAN_PARENT',
  UpperRomanParen: 'UPPER_ROMAN_PAREN'
};
exports.OutlineTypes = OutlineTypes;
var EditorBodyId = 'editor-body';
exports.EditorBodyId = EditorBodyId;
var RetakePanelType = 'RetakePanel';
exports.RetakePanelType = RetakePanelType;
var CustomNavType = 'NavPanel';
exports.CustomNavType = CustomNavType;
var NavStatuses = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Complete: 'Complete'
};
exports.NavStatuses = NavStatuses;
var ScrollableAnnotations = [AnnotationTypes.Addition, AnnotationTypes.Correct, AnnotationTypes.Highlight, AnnotationTypes.Incorrect, AnnotationTypes.Strikethrough, AnnotationTypes.Focus, AnnotationTypes.Delete_v2, AnnotationTypes.Addition_v2, AnnotationTypes.AnswerBase, AnnotationTypes.Choice];
exports.ScrollableAnnotations = ScrollableAnnotations;
var NotificationTypes = {
  TeamReport: 'TEAM_REPORT',
  TimeRelease: 'TIME_RELEASE',
  WelcomeEmail: 'WELCOME_EMAIL',
  ResetPassword: 'RESET_PASSWORD',
  NewCourse: 'NEW_COURSE',
  CourseResult: 'COURSE_RESULT',
  Feedback: 'FEEDBACK',
  System: 'SYSTEM'
};
exports.NotificationTypes = NotificationTypes;
var ExcerptPositions = {
  Beginning: 'BEG',
  Middle: 'MID',
  End: 'END'
};

/* Server specific types */
exports.ExcerptPositions = ExcerptPositions;
var CopyTypes = {
  Course: 'Course',
  Module: 'Module',
  Slide: 'Slide'
};
exports.CopyTypes = CopyTypes;
var TimeEventTypes = {
  Start: 'S',
  Interval: 'I',
  Submit: 'SU',
  Complete: 'C',
  Back: 'B',
  Next: 'N',
  Stop: 'X'
};
exports.TimeEventTypes = TimeEventTypes;